<template>
  <label class="radio-chips mr-2 mb-0" v-on:click="$emit('click')">
    <input :type="type" :name="name" :value="value" :checked="checked" v-on:change="$emit('change', value)">
    <span class="radio-chips__content">
      <span class="radio-chips__title">{{title}}</span>
    </span>
  </label>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'radio'
    },
    value: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    }
  }
}
</script>
